import { format } from 'date-fns'
import { enUS, it } from 'date-fns/locale'
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'
import i18next from 'i18next'

const locales = {
  en: enUS,
  it,
}

export const formatDateTime = (date: Date) => {
  // Please note that most of the time, the input parameter data
  // is a string in ISO format, coming from the backend.
  // However, we need this typing in order to match with mapped API type.

  const options = { locale: locales[i18next.language as 'en' | 'it'] }

  // Formatting date to UTC is not supported by date-fns, we need
  // this workaround to convert date to UTC
  // See https://github.com/date-fns/date-fns/issues/1401

  const d = new Date(date)

  const dateStr = format(d, 'PP', options)
  const timeStr = format(d, 'p', options)

  return `${dateStr} ${timeStr}`
}

export const formatDateTimeShort = (date: Date) => {
  const options = { locale: locales[i18next.language as 'en' | 'it'] }
  const d = new Date(date)

  const dateStr = format(d, 'yyyy-MM-dd', options) // Formato YYYY-MM-DD
  const timeStr = format(d, 'HH:mm:ss', options) // Formato HH:mm:ss

  return `${dateStr}-${timeStr}`
}

/**
 * @deprecated You should not need to change date timezone. Before using this
 *             function please think to your design and understand how this can
 *             complicate a the logic.
 */
export const zonedDateToUtc = (date: Date) => zonedTimeToUtc(date, 'UTC')

/**
 * @deprecated You should not need to change date timezone. Before using this
 *             function please think to your design and understand how this can
 *             complicate a the logic.
 */
export const utcToZonedDate = (date: Date) => utcToZonedTime(date, 'UTC')
